<template>
  <div
    class="
      locked-post-wrapper
      flex
      bg-white
      locked
      justify-center
      items-center
      flex-col
      btn-radius
      relative
    "
    :class="[!isPreview ? '' : 'preview-only']"
  >
    <div class="offer-preview shadow-lg" v-if="offer">
      <div
        class="w-full h-full offer-preview-inner shadow-2xl rounded-lg"
        v-html="offer.content"
      ></div>
    </div>
    <div v-else class="offer-preview shadow-lg text-center">
      <div class="text-2xl uppercase font-bold mb-2 text-grey-800">
        Premium Content
      </div>
      <div class="text-sm text-grey-600" v-if="unlockDate">
        This lesson will unlock on {{ unlockDate }}
      </div>
    </div>
  </div>
</template>
<script>
import UnlockButton from './button';
// import LockedIcon from '../../../assets/images/icons/locked.svg';

export default {
  name: 'LockedPost',
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    offer: {},
    unlockDate: {},
    getThemeSettings: {},
  },
  methods: {
    goToSalesPage(url) {
      console.log('im called');
      window.open(url, '_blank');
    },
  },
  components: {
    UnlockButton,
  },
};
</script>
<style lang="scss">
.locked-post-wrapper {
  .add-button {
    margin: 20px 0 0;
    display: inline-block;
    border-radius: 6px;
    color: #fff !important;
    font-size: 16px;
    font-weight: bold;
    pointer-events: none;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    &::before,
    &::after {
      content: none !important;
    }
    &.align-left {
      left: 0;
      transform: none;
    }
    &.align-right {
      left: 100%;
      transform: translateX(-100%);
    }
    a {
      cursor: pointer;
      display: block;
      text-decoration: none !important;
      padding: 10px 40px;
      border-radius: 6px;
      text-align: center;
    }
  }
}
.locked-post-wrapper.preview-only {
  .custom-delete-btn {
    display: none;
  }
  .add-button {
    pointer-events: all;
  }
}
.offer-preview {
  position: static;
  width: 100%;
  z-index: 9;
  background: #9e9e9e45;
  top: 0px;
  padding: 38px 20px;
  height: 100%;
  strong {
    font-weight: 700;
  }
  h2 {
    font-size: 19.5px;
  }
  h3 {
    font-size: 15.21px;
  }
  p {
    font-size: 13px;
  }
  .text-grey-700 {
    color: #545671;
  }
  .text-deep-dark {
    color: #191d3a;
  }
  .offer-preview-inner {
    background-color: #fefefe;
    margin: 0px auto;
    width: 95%;
    padding: 25px;
  }
}
</style>